import type { AnnouncementBannerDisplayState } from './get-announcement-banner-display-state/types.tsx';

export const JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY =
	'jsm-grace-period-announcement-dismiss-state' as const;

export const DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE: AnnouncementBannerDisplayState = {};

export const FALLBACK_GP_END_DATE = new Date('10/16/2025');
